import { Link } from 'react-router';
import { ArrowUpRight } from '@/icons';

export function CtaBlock() {
  return (
    <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] bg-accent text-bg p-10 md:p-16 lg:p-24 grid lg:grid-cols-[1.3fr_auto] gap-8 items-end">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.08em] text-bg/70">Ready?</span>
          <h2 className="font-display font-black text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.95] tracking-tight">
            Start a project.
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-bg/80">
            One email. A brief reply within one business day. No long forms, no sales funnels.
          </p>
        </div>
        <Link
          to="/contact"
          className="inline-flex items-center gap-3 bg-bg text-ink-primary px-8 py-5 rounded-full font-semibold text-lg transition-all duration-200 hover:scale-[1.02] self-start lg:self-end"
        >
          Write to us <ArrowUpRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
